import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject } from 'rxjs';
import { FloorPlanInfo, Place } from 'src/app/interfaces/interfaces';
import { FloorplanStore } from 'src/app/stores/floorplan.store';

@Injectable({
  providedIn: 'root'
})
export class FloorplanSearchService {
  public floorplanSearchState$ = new BehaviorSubject<FloorplanSearchState>(new FloorplanSearchDefaultState())
  public floorplanSearchState = new FloorplanSearchRequestState();
  public floorplanSearchDefaultState = new FloorplanSearchDefaultState();
  public triggerFloorplanSearchEffect$ = new BehaviorSubject<boolean>(false)
  public desiredFloorplan$ = new BehaviorSubject<FloorPlanInfo>(null)

  constructor(private router:Router, private floorplanStore: FloorplanStore) {  }



  applySearch(floorplan: FloorPlanInfo) {
    //to reset the floorplan before fetching the next one
    this.floorplanSearchState$.next(this.floorplanSearchDefaultState);
    this.triggerFloorplanSearchEffect$.next(false);
    
    
    this.floorplanSearchState = new FloorplanSearchRequestState();
    this.desiredFloorplan$.next(floorplan)
    this.floorplanSearchState.floorplanSearchRequest = floorplan    
    this.floorplanSearchState$.next(this.floorplanSearchState)
    this.triggerFloorplanSearchEffect$.next(true);
    if(this.router.url.includes("favorite-floor-plans")) this.router.navigate(["/floor-plan", floorplan._id])

  }


  resetDefaultSearchState() {
    this.floorplanSearchState$.next(this.floorplanSearchDefaultState);
    this.floorplanSearchState = new FloorplanSearchDefaultState();
    this.triggerFloorplanSearchEffect$.next(false);
    if(!this.router.url.includes("favorite-floor-plans")) this.router.navigate(["/tabs/favorite-floor-plans"])

  }

  resetDefaultSearchStateFromBackdrop() {
    this.floorplanSearchState$.next(this.floorplanSearchDefaultState);
  }
  
  openMap(place: Place){
    //this.desiredFloorMap = this.floorplansInfo?.find(floorplan=> JSON.parse(floorplan.floorMapImage).objects.find(object => object.name == resourseUPN) != undefined);
    let desiredFloorMap = place.floorMapId ? this.floorplanStore.allFloorplansList().find(floorplan => floorplan._id == place.floorMapId) : null;
    desiredFloorMap.triggerringUPN= place.emailAddress ;
    this.applySearch(desiredFloorMap)
    this.router.navigate(["/floor-plan", desiredFloorMap._id])
  }

  
}


export interface FloorplanSearchState {
  icon: string,
  color: string,
  fill: string,
  floorplanSearchRequest?: FloorPlanInfo
}


export class FloorplanSearchDefaultState implements FloorplanSearchState {
  icon = 'filter-outline';
  color = 'light';
  fill = 'solid';
  floorplanSearchRequest = null

}

export class FloorplanSearchRequestState implements FloorplanSearchState {
  icon = 'filter-outline';
  color = 'danger';
  fill = 'solid';
  floorplanSearchRequest = null;

}

